import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import HeaderSmall from '../HeaderSmall/HeaderSmall';

import URI from '../../constants/serverUrl';

// Landing page for the OnePageCRM form's "redirect after submission" setting.
// The OnePageCRM form lives in a cross-origin iframe, so the page can't detect
// its submit directly. Instead, GetSDS stashes the productId in sessionStorage
// before submission, the form redirects here, and we read it back to trigger
// the actual SDS download.
class SdsDownload extends Component {

  state = {
    productId: null,
  }

  componentDidMount() {
    let productId = null;
    try {
      productId = sessionStorage.getItem('sdsProductId');
    } catch (e) { /* storage unavailable — fall through to the error view */ }

    this.setState({ productId });

    if (productId) {
      window.location.replace(URI + '/product_download/' + productId + '/sds/');
    }
  }

  render() {
    const { productId } = this.state;

    return (
      <div>
        <HeaderSmall title="Download SDS" />
        <div className="row" style={{ backgroundColor: '#FFF', paddingTop: '30px', paddingBottom: '30px' }}>
          <div className="col-md-3"></div>
          <div className="col-md-6">
            <div className="well well-md">
              {productId ? (
                <div>
                  <h3>Thank you</h3>
                  <p>Your download should begin shortly, or use <a href={URI + '/product_download/' + productId + '/sds/'}>this link</a> to download the SDS directly.</p>
                </div>
              ) : (
                <div>
                  <h3>We couldn't find your SDS download</h3>
                  <p>Please return to the product page and request the SDS again, or use our <NavLink to="/contact">contact form</NavLink> to get in touch.</p>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-3"></div>
        </div>
      </div>
    );
  }
}

export default SdsDownload;



// WEBPACK FOOTER //
// src/components/pages/SdsDownload.js